import { initReactI18next } from 'react-i18next';
import en from './translations/en.json';
import i18n from 'i18next';
import se from './translations/se.json';

export const resources = {
  en: {
    translation: en,
  },
  se: {
    translation: se,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'se',
  fallbackLng: 'se',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
